// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file inventory/get_inventory.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Filter, InventoryLineItem } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetInventoryRequest
 */
export class GetInventoryRequest extends Message<GetInventoryRequest> {
  /**
   * The page number for pagination
   *
   * @generated from field: int32 page = 1;
   */
  page = 0;

  /**
   * The number of items per page
   *
   * @generated from field: int32 page_size = 2;
   */
  pageSize = 0;

  /**
   * Optional filter to apply on the inventory items
   *
   * @generated from field: com.neulink.pharmacy.Filter filter = 3;
   */
  filter?: Filter;

  constructor(data?: PartialMessage<GetInventoryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetInventoryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "page", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "filter", kind: "message", T: Filter },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetInventoryRequest {
    return new GetInventoryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetInventoryRequest {
    return new GetInventoryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetInventoryRequest {
    return new GetInventoryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetInventoryRequest | PlainMessage<GetInventoryRequest> | undefined, b: GetInventoryRequest | PlainMessage<GetInventoryRequest> | undefined): boolean {
    return proto3.util.equals(GetInventoryRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetInventoryResponse
 */
export class GetInventoryResponse extends Message<GetInventoryResponse> {
  /**
   * List of inventory items
   *
   * @generated from field: repeated com.neulink.pharmacy.InventoryLineItem items = 1;
   */
  items: InventoryLineItem[] = [];

  /**
   * Total number of inventory items matching the filter
   *
   * @generated from field: int32 total_count = 2;
   */
  totalCount = 0;

  constructor(data?: PartialMessage<GetInventoryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetInventoryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: InventoryLineItem, repeated: true },
    { no: 2, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetInventoryResponse {
    return new GetInventoryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetInventoryResponse {
    return new GetInventoryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetInventoryResponse {
    return new GetInventoryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetInventoryResponse | PlainMessage<GetInventoryResponse> | undefined, b: GetInventoryResponse | PlainMessage<GetInventoryResponse> | undefined): boolean {
    return proto3.util.equals(GetInventoryResponse, a, b);
  }
}

